<div
    class="option-group-container"
    msOptionGroupRenderer
    [maxColumns]="4"
    [tolerance]="50"
    [responsiveColumns]="0"
    [resetClass]="true"
    [optionPickClass]="'.option-group'"
    (rerender)="calculateLimit($event)">
    <ng-container *ngFor="let vm of vms$ | async | slice: 0 : limit; let i = index; trackBy: trackItem">
        <div
            class="option-group"
            [ngClass]="{
                'right-column': hasDoubleRightBorder(i),
                'bottom-row': hasDoubleBottomBorder(i),
            }">
            <div class="option-details">
                <span class="option-name">{{ columns ? vm.option.name : '' }}</span>
                <span class="event-name" *ngIf="!sameEvent">
                    {{ vm.eventModel.name }}
                </span>

                <ms-event-info class="event-timer" *ngIf="!sameEvent" [disableBadges]="true" [event]="vm.eventModel" />
            </div>
            @if (vm.previousOdds) {
                <div class="previous-odds-container">
                    <span class="previous-odds-title">{{ sitecore.globalMessages.PreviousOddsTitle }}</span>
                    <s class="previous-odds">
                        {{ vm.previousOdds | msNativePriceFormatter }}
                    </s>
                </div>
            }
            <ms-option
                [class.boosted-option]="vm.previousOdds"
                [optionGroup]="vm.optionGroup"
                [option]="vm.option"
                [event]="vm.eventModel"
                [hideAttributeValue]="hasNameOverride(vm.option.id)"
                [tracking]="{ source: tracking, moduleType: trackingModuleType }">
                @if (vm.previousOdds) {
                    <vn-icon
                        name="theme-acca-boost"
                        [ngClass]="isEpcotEnabled ? 'acca-boost-alignment' : 'icon'"
                        [size]="isEpcotEnabled ? '12' : '16'" />
                }
            </ms-option>
        </div>
    </ng-container>
    <div class="show-more-less-button" *ngIf="!columnsNotReady && limit < vmCount" [ngClass]="{ expanded: limit >= vmCount }" (click)="showMarkets()">
        {{ sitecore.event.ShowMore }}
        <vn-icon class="icon-alignment" name="theme-down" size="14" />
    </div>
</div>

<div class="all-markets-link" *ngIf="!columnsNotReady && this.pod.link && limit >= vmCount">
    <ms-item [href]="this.pod.link.url" [tracking]="undefined" (itemClicked)="trackBottomLink()"
        ><span class="title" item-title [innerHtml]="this.pod.link.text || sitecore.event.ShowMore | msTrust: 'html'"></span>
    </ms-item>
</div>
